var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:['Logo', _vm.getCurrentTheme.type],attrs:{"src":_vm.imageSrc,"title":_vm.imageTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }